import { useAppDispatch, useAppSelector } from "@app/hooks";
import { useApi } from "@services/useApi";
import { useEffect, useState } from "react";
import { RemoteAssessment, updateRemoteAssessments } from "@store/locationsSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Colors } from "@styles/colors";
import { RemoteAssessments } from "../components/remoteassessments/RemoteAssessments";
import { NoRemoteAssessments } from "../components/NoRemoteAssessments";

export const AdminAssessmentsRemote = (): JSX.Element => {
    const [getDataLoading, setGetDataLoading] = useState(false);

    const dispatch = useAppDispatch();

    const { getRemoteAssessments } = useApi();
    const remoteAssessments = useAppSelector((x) => x.orgLocations.remoteAssessments);

    const currentLocation = useAppSelector((x) => x.orgLocations.currentLocation);

    const handleGetRemoteAssessments = async (): Promise<void> => {
        setGetDataLoading(true);
        const assessments = await getRemoteAssessments(currentLocation!.id).finally(() => {
            setGetDataLoading(false);
        });
        dispatch(updateRemoteAssessments(assessments));
    };

    useEffect(() => {
        void handleGetRemoteAssessments();
    }, [currentLocation?.id]);

    return (
        <>
            {getDataLoading ? (
                <div className="is-flex is-justify-content-center mt-4">
                    <FontAwesomeIcon icon={faSpinner} size="4x" color={Colors.darkBlue} className="fa-spin" />
                </div>
            ) : remoteAssessments?.length ? (
                <RemoteAssessments
                    assessments={remoteAssessments.map(
                        (x) =>
                            ({
                                examineeFirstName: x.examineeFirstName,
                                examineeLastName: x.examineeLastName,
                                id: x.id,
                                examineeEmail: x.examineeEmail,
                                examineePhoneNumber: x.examineePhoneNumber,
                                createdBy: x.createdBy,
                                sentAt: x.sentAt,
                                scheduledFor: x.scheduledFor,
                                linkStatus: x.linkStatus,
                                examineeId: Number(x.examineeId)
                            } as RemoteAssessment)
                    )}
                    onClick={() => {}}
                />
            ) : (
                <NoRemoteAssessments />
            )}
        </>
    );
};
